import React, { useCallback } from "react";

// mascaras
import { cpf, cep, telefone, telefone1, cnpj } from "./Mask";

const Input = ({ mask, ...props }) => {
  const handleKeyUp = useCallback(
    (e) => {
      if (mask === "cep") {
        return cep(e);
      }
      if (mask === "cpf") {
        return cpf(e);
      }

      if (mask === "telefone") {
        return telefone(e);
      }

      if (mask === "telefone1") {
        return telefone1(e);
      }

      if (mask === "cnpj") {
        return cnpj(e);
      }
    },
    [mask]
  );

  return <input {...props} onKeyUp={handleKeyUp} />;
};

export default Input;
